//called from main.js in RootView
Backbone.Radio.channel('views').reply('ribbon-pledge',function(){

	var start 			= moment("2025-06-16T06:00:00");
	var end   			= moment("2025-06-30T23:59:00");
	var lastDay   		= moment("2021-12-13T06:00:00");
	var lastDayEnd  	= moment("2021-12-15T23:00:00");
/*
	var lastDay   		= moment("2021-07-09T00:00:00");
	var lastDayEnd  	= moment("2020-12-13T17:00:00");
*/
	var thankYouStart 	= moment("2023-03-27T09:01:00");
	var thankYouEnd   	= moment("2023-03-29T23:00:00");
	
	var htm  = "", today, pledgeImgs,EOFY,GivingDays,promotionImgs, commonImgs, a;
	
	pledgeImgs    = "https://pages.whro.org/assets/imgs/pledge/tvribbonfeatures/";
	EOFY          = "https://www.whro.org/images/pledge/EOFY/";
	EOCY		  = "https://pages.whro.org/assets/imgs/pledge/eocy/";
	GivingDays	  = "https://pages.whro.org/assets/imgs/pledge/publicMediaGivingDays/";
	Champion	  = "https://pages.whro.org/assets/imgs/pledge/champion/";
	promotionImgs = "https://www.whro.org/images/pledge/promoting-shows/";
	commonImgs    = "https://pages.whro.org/assets/imgs/pledge/";

	if(moment().isBetween(start,end)){
 		today = moment().format('MMDDYY');
	//	today = "061325"; //testing 		
  
	
		
		/* TV Pledge */
		
/*
	   		 htm += '<style>';
	    	 htm += '.pledgeBanner{ background:url("'+commonImgs+'swyl_bkg_corpBlue.jpg") repeat-x transparent 0 0; height:90px; }';
			 htm += '.pledgeBanner{ background-color:#0b4f71; height:90px; }';
			 htm += '.pledgeBanner .siteBannerInner{ height:90px; justify-content:space-between; }';
			 htm += '	@media (max-width:750px){ .pledgeBanner .siteBannerInner { justify-content:space-around; } }';
			 htm += '.pledgeBanner .mdAmounts a{ width:216px; height:90px; background:url("'+commonImgs+'btn_donateNow_Off.png") no-repeat transparent 0 0; display:inline-block; text-indent:-9000px; }';
			 htm += '.pledgeBanner .mdAmounts a:hover{ background:url("'+commonImgs+'btn_donateNow_On.png") no-repeat transparent 0 0; }';
			 htm += '.pledgeBanner .smAmounts a{ width:103px; height:90px; background:url("'+commonImgs+'btn_donateNow_sq_Off.png") no-repeat transparent 0 0; display:inline-block; text-indent:-9000px; }';
			 htm += '.pledgeBanner .smAmounts a:hover{ background:url("'+commonImgs+'btn_donateNow_sq_On.png") no-repeat transparent 0 0; }';
			 htm += '	.pledgeBanner .mdAmounts{ line-height:1.5em; padding: 25px 0; }';
			 htm += '</style>';
	         htm += '<div class="siteBanner pledgeBanner">';
			 htm += 		'<div class="container siteBannerInner d-flex">';
			 htm += 			'<img class="bannerLogo d-none d-md-block" src="'+commonImgs+'swylHeart_l.png" alt="" />';
			 htm += 			'<img class="bannerLogo d-md-none" src="'+commonImgs+'swylHeart_s.png" alt="" />';
			 htm += 			'<img class="d-none d-lg-block" src="'+pledgeImgs+today+'_599.png" alt="" />';
			 htm += 			'<img class="d-none d-md-block d-lg-none" src="'+pledgeImgs+today+'_250.png" alt="" />';
			 htm += 			'<div class="amounts d-none d-md-block mdAmounts">';
			 htm += 				'<a href="https://secure.whro.org/site/Donation2?1400.donation=form1&df_id=1400&set.custom.Package=OnlineMainBanner" target="_blank" rel="noopener">Support Now</a>';
			 htm += 			'</div>';
			 htm += 			'<div class="amounts d-md-none smAmounts">';
			 htm += 				'<a href="https://secure.whro.org/site/Donation2?1400.donation=form1&df_id=1400&set.custom.Package=OnlineMainBanner" target="_blank" rel="noopener">Support Now</a>';
			 htm += 			'</div>';
			 htm += 		'</div>';
			 htm += '</div>';
		
*/
			
		/* EOFY Banner*/

/*
		
	    	htm += '<style>';
	    	htm += '.pledgeBanner{ background:url("'+EOCY+'EOCY_ribbon_bkg.jpg") repeat-x transparent 0 0; height:90px;  };';
			htm += '.pledgeBanner .siteBannerInner { height:90px; justify-content:space-around; }';
			htm += '.pledgeBanner a{ width:130px; height:90px; background:url("'+EOCY+'EOCY_ribbon_btnOff_s.png") no-repeat transparent 0 0; display:inline-block; text-indent:-9000px;margin-top: 25px; }';
			htm += '.pledgeBanner a:hover{ background:url("'+EOCY+'EOCY_ribbon_btnOn_s.png") no-repeat transparent 0 0; }';
			htm += '@media (min-width:768px){ .pledgeBanner a { width:182px; margin-top: 16px; background:url("'+EOCY+'EOCY_ribbon_btnOff.png") no-repeat transparent 0 0;} }';
			htm += '@media (min-width:768px){ .pledgeBanner a:hover{ background:url("'+EOCY+'EOCY_ribbon_btnOn.png") no-repeat transparent 0 0; }  }';
			htm += '</style>';
	        htm += '<div class="siteBanner pledgeBanner">';
			htm += 		'<div class="container siteBannerInner d-flex" style="justify-content: space-around; height:90px;">';
			htm += 			'<img class="d-none d-md-none d-lg-block" src="'+EOCY+'EOCY_ribbon_tag.png" alt="" />';
		    htm +=			'<img class="d-none d-lg-none d-md-block" src="'+EOCY+'EOCY_ribbon_tag_m.png" alt="" />';
			htm += 			'<img class="d-md-none" src="'+EOCY+'EOCY_ribbon_tag_s.png" alt="" />';
			htm += 			'<div class="amounts">';
			htm += 				'<a class="promo" href="https://secure.whro.org/site/Donation2?1400.donation=form1&df_id=1400&set.custom.Package=EOCY" target="_blank" rel="noopener"></a>';
			htm += 			'</div>';
			htm += 		'</div>';
			htm += '</div>';

		
*/	
		
		/* Public Media Giving Days Ribbon */

/*
		
	    	htm += '<style>';
	    	htm += '.pledgeBanner{ background:url("'+GivingDays+'ribbon_publicMediaGivingDays_bkg.jpg") repeat-x transparent 0 0; height:90px;  };';
			htm += '.pledgeBanner .siteBannerInner { height:90px; justify-content:space-around; }';
			htm += '.pledgeBanner a{ width:130px; height:90px; background:url("'+GivingDays+'ribbon_publicMediaGivingDays_btnOff.png") no-repeat transparent 0 0; display:inline-block; text-indent:-9000px; }';
			htm += '.pledgeBanner a:hover{ background:url("'+GivingDays+'ribbon_publicMediaGivingDays_btnOn.png") no-repeat transparent 0 0; }';
			htm += '@media (min-width:768px){ .pledgeBanner a { width:182px; background:url("'+GivingDays+'ribbon_publicMediaGivingDays_btnOff.png") no-repeat transparent 0 0;} }';
			htm += '@media (min-width:768px){ .pledgeBanner a:hover{ background:url("'+GivingDays+'ribbon_publicMediaGivingDays_btnOn.png") no-repeat transparent 0 0; }  }';
			htm += '</style>';
	        htm += '<div class="siteBanner pledgeBanner">';
			htm += 		'<div class="container siteBannerInner d-flex" style="justify-content: space-around; height:90px;">';
			htm += 			'<img class="d-none d-md-none d-lg-block" src="'+GivingDays+'ribbon_publicMediaGivingDays_LogoAndTag.png" alt="" />';
		    htm +=			'<img class="d-none d-lg-none d-md-block" src="'+GivingDays+'ribbon_publicMediaGivingDays_LogoAndTag.png" alt="" />';
			htm += 			'<img class="d-md-none" src="'+GivingDays+'ribbon_publicMediaGivingDays_logo.jpg" alt="" />';
			htm += 			'<div class="amounts">';
			htm += 				'<a class="promo" href="https://secure.whro.org/site/Donation2?1400.donation=form1&df_id=1400&set.custom.Package=PMGivingDays" target="_blank" rel="noopener"></a>';
			htm += 			'</div>';
			htm += 		'</div>';
			htm += '</div>';

	*/	
		
		/* Champion WHRO Ribbon */


		
	    	htm += '<style>';
	    	htm += '.pledgeBanner{ background:url("'+Champion+'championWHRO_ribbon_bkg.jpg") repeat-x transparent 0 0; height:90px;  };';
			htm += '.pledgeBanner .siteBannerInner { height:90px; justify-content:space-around; }';
			htm += '.pledgeBanner a{ width:250px; height:59px; margin-top:15px; background:url("'+Champion+'championWHRO_ribbon_btnOff.png") no-repeat transparent 0 0; display:inline-block; text-indent:-9000px; }';
			htm += '.pledgeBanner a:hover{ background:url("'+Champion+'championWHRO_ribbon_btnOn.png") no-repeat transparent 0 0; }';
			htm += '@media (min-width:768px){ .pledgeBanner a { width:250px; background:url("'+Champion+'championWHRO_ribbon_btnOff.png") no-repeat transparent 0 0;} }';
			htm += '@media (min-width:768px){ .pledgeBanner a:hover{ background:url("'+Champion+'championWHRO_ribbon_btnOn.png") no-repeat transparent 0 0; }  }';
			htm += '</style>';
	        htm += '<div class="siteBanner pledgeBanner">';
			htm += 		'<div class="container siteBannerInner d-flex" style="justify-content: space-around; height:90px;">';
			htm += 			'<img class="d-none d-md-none d-lg-block" src="'+Champion+'championWHRO_ribbon_tag.png" alt="" />';
		    htm +=			'<img class="d-none d-lg-none d-md-block" src="'+Champion+'championWHRO_ribbon_tag_m.png" alt="" />';
			htm += 			'<img class="d-md-none" src="'+Champion+'championWHRO_ribbon_tag_s.png" alt="" />';
			htm += 			'<div class="amounts">';
			htm += 				'<a class="promo" href="https://secure.whro.org/site/Donation2?1400.donation=form1&df_id=1400&set.custom.Package=Champion" target="_blank" rel="noopener"></a>';
			htm += 			'</div>';
			htm += 		'</div>';
			htm += '</div>';

		


		/* Promotional Banner  for Shows */

/*
    	htm += '<style>';
    	htm += '.pledgeBanner{ background:url("'+promotionImgs+'bkg.jpg") repeat-x transparent 0 0; height:90px;  };';
		htm += '.pledgeBanner .siteBannerInner{ height:90px; justify-content:space-between; }';
		htm += '.pledgeBanner a{ height:90px; display:inline-block; text-indent:-9000px; }';
		htm += '</style>';
        htm += '<div class="siteBanner pledgeBanner">';
		htm += 		'<div class="container siteBannerInner d-flex" style="justify-content: space-between;">';
		htm += 			'<img class="d-none d-lg-block" src="'+promotionImgs+'titleCard_large.png" alt="" />';
		htm += 			'<img class="d-none d-sm-block d-lg-none" src="'+promotionImgs+'titleCard_388.png" alt="" />';
		htm += 			'<img class="d-sm-none" src="'+promotionImgs+'titleCard_190.png" alt="" />';
		htm += 			'<div class="amounts">';
		htm += 				'<a class="promo" href="https://mediaplayer.whro.org/program/downton-abbey" target="_blank" rel="noopener">Watch Now</a>';
		htm += 			'</div>';
		htm += 		'</div>';
		htm += '</div>';
*/
		
		/*

		htm += '<style>';
    	htm += '.pledgeBanner{ background:url("'+EOFY+'EOFY2023_ribbon_bkg.jpg") repeat-x transparent 0 0; height:90px;  };';
		htm += '.pledgeBanner .siteBannerInner { height:90px; justify-content:space-between; }';
 		htm += '.pledgeBanner a{ width:180px; height:59px; background:url("'+EOFY+'EOFY2023_ribbon_btnOff.png") no-repeat transparent 0 0; display:inline-block; text-indent:-9000px; }';
		htm += '.pledgeBanner a:hover{ background:url("'+EOFY+'EOCY21_ribbonMP_btnOn.png") no-repeat transparent 0 0; }';
		htm += '@media (min-width:768px){ .pledgeBanner a { width:180px;background:url("'+EOFY+'EOFY2023_ribbon_btnOff.png") no-repeat transparent 0 0;  margin-top: 20px; margin-bottom: 20px;} }';
		htm += '@media (min-width:768px){ .pledgeBanner a:hover{ background:url("'+EOFY+'EOFY2023_ribbon_btnOn.png") no-repeat transparent 0 0; }  }';
		htm += '@media (max-width:320px){ .pledgeBanner .siteBannerInner { text-align: center; }'
 		htm += '.pledgeBanner .siteBannerInner img,.pledgeBanner .siteBannerInner .amounts  { margin-top: 5px;}'
 		htm += '.pledgeBanner { background-position: 55%; }'
		htm += ' }';
		htm += '@media (max-width:767px){ .promo{margin-top:15px; } }';
		htm += '</style>';
        htm += '<div class="siteBanner pledgeBanner">';
		htm += 		'<div class="container siteBannerInner d-flex" style="justify-content: space-between; height:90px;">';
		htm += 			'<img class="d-none d-lg-block" src="'+EOCY+'EOCY2023_ribbon_tag.png" alt="" />';
		htm += 			'<img class="d-none d-md-block d-lg-none" src="'+EOCY+'EOCY2023_ribbon_tag_m.png" alt="" />';
		//htm += 			'<img class="d-none d-lg-block" src="'+EOCY+'EOCY21_ribbon_tag_l.png" alt="" />';
		//htm += 			'<img class="d-none d-md-block d-lg-none" src="'+EOCY+'EOCY21_ribbon_tag_s.png" alt="" style="width: 89px;" />';
		htm += 			'<img class="d-md-none" src="'+EOCY+'EOCY2023_ribbon_tag_s.png" alt="" />';
		htm += 			'<div class="amounts">';
		htm += 				'<a class="promo" href="https://members.whro.org/?technique=OnlineMainBanner" target="_blank" rel="noopener"></a>';
		htm += 			'</div>';
		htm += 		'</div>';
		htm += '</div>';

*/
			
			
		/* 
			Random Message
			htm  = '<div style="background:#333;color:#dcdcdc;"><div class="container"><div class="row"><div class="col"><p class="text-center m0 p2" style="line-height:1">WHRO will be performing equipment upgrades Friday, September 7th beginning at 1pm. During this time, many of our services including radio broadcasts, WHRO hosted websites and email, and online media streaming will be unavailable. Thank you for your understanding and patience.</p></div></div></div></div>';
		*/
		
		
		/* 
			Radio Pledge 
			- Member Counts and Amount Raised 
		*/

/*		
		htm += '<style>';
			htm += '	.pledgeBanner{ font-family:Helvetica,arial;font-weight:bold;color:#fff; background-color:#4ea279; height:90px; }';
			htm += '.pledgeBanner{ background:url("'+commonImgs+'swyl_bkg_springGreen.jpg") repeat-x transparent 0 0; height:90px; }';
			htm += '	.pledgeBanner .siteBannerInner{ height:90px; justify-content:space-between; }';
			htm += '	.pledgeBanner span{ align-self:center; line-height:1.1; vertical-align:sub; text-align:center; }';
			htm += '	.pledgeBanner span span.d-lg-inline{ vertical-align:baseline; }';
			htm += '	.pledgeBanner span .pledgeCallout{ color:#fadc09;font-size:32px;}';
			htm += '	.pledgeBanner img{ height:100%; }';
			htm += '	.pledgeBanner .bannerLogo{ margin-top:0px; margin-left:1rem; }';
			htm += '	.pledgeBanner a{ width:112px; height:90px; background:url("'+commonImgs+'btn_donateNow_sqGreen_Off.png") no-repeat transparent 0 0; display: inline-block; text-indent: -9000px; }';
			htm += '	.pledgeBanner a:hover{ background:url("'+commonImgs+'btn_donateNow_sqGreen_On.png") no-repeat transparent 0 0; }';
			htm += '	@media (max-width:575px){ .pledgeBanner .siteBannerInner{ padding-left:4px };  }';
			htm += '	@media (max-width:575px){ .pledgeBanner }';
			htm += '</style>';
			htm += '<div class="siteBanner pledgeBanner">';
			htm += '	<div class="container siteBannerInner d-flex pr0">';
			htm += '		<img class="bannerLogo d-md-none" src="'+commonImgs+'swylHeart_s.png">';
			htm += 			'<img class="bannerLogo d-none d-md-inline" src="'+commonImgs+'swylHeart_l.png" alt="" />';
			htm += '		<span class="d-none d-md-inline">THANKS&nbsp;TO&nbsp;<span class="pledgeCallout pledgeMemberCount"></span>&nbsp;MEMBERS, WE`VE&nbsp;RAISED&nbsp;<span class="pledgeCallout pledgeRaisedAmount"></span><span class="d-none d-lg-inline">&nbsp;SO&nbsp;FAR</span></span>';
			htm += '		<div class="amounts">';
			htm += '			<div style="margin-left:auto">';
			htm += '				<a class="d-inline-block" href="https://secure.whro.org/site/Donation2?1400.donation=form1&df_id=1400&set.custom.Package=OnlineMainBanner" target="_blank">Support Now</a>';
			htm += '			</div>';
			htm += '		</div>';
			htm += '	</div>';
			htm += '</div>';
		
			a = $.ajax({ url : APP_CONFIG.MEMBERS_API_ROOT+'api/v1/pledge-ribbon' });
			a.done(function(res){
				console.log("res", res)
				//add commas back in
				res.amount_raised = res.amount_raised.replace(/\B(?=(?:\d{3})+(?!\d))/g, ",");
				
				$(document).ready(function(){
					$('.pledgeMemberCount').html( +res.total_member_count );
					$('.pledgeRaisedAmount').html("$"+res.amount_raised );
				});
			});

		

	}else if(moment().isBetween(lastDay, lastDayEnd)){	
			today = moment().format('MMDDYY');
			
			htm += '<style>';
	    	htm += '.pledgeBanner{ background-color: #67aee0; height:88px; }';
			htm += '.pledgeBanner .siteBannerInner{ height:90px; justify-content:space-between; }';
			htm += '	@media (max-width:750px){ .pledgeBanner .siteBannerInner { justify-content:space-around; } }';
			htm += '.pledgeBanner .mdAmounts a{ width:217px; height:90px; background:url("'+commonImgs+'btn_donateNow_Off.png") no-repeat transparent 0 0; display:inline-block; text-indent:-9000px; }';
			htm += '.pledgeBanner .mdAmounts a:hover{ background:url("'+commonImgs+'btn_donateNow_On.png") no-repeat transparent 0 0; }';
			htm += '.pledgeBanner .smAmounts a{ width:103px; height:90px; background:url("'+commonImgs+'btn_donateNow_sq_Off.png") no-repeat transparent 0 0; display:inline-block; text-indent:-9000px; }';
			htm += '.pledgeBanner .smAmounts a:hover{ background:url("'+commonImgs+'btn_donateNow_sq_On.png") no-repeat transparent 0 0; }';
			htm += '	.pledgeBanner .mdAmounts{ line-height:1.5em; padding: 25px 0; }';
			htm += '</style>';
	        htm += '<div class="siteBanner pledgeBanner">';
			htm += 		'<div class="container siteBannerInner d-flex">';
			htm += 			'<img class="bannerLogo d-none d-lg-block" src="'+commonImgs+'swylHeart_l.png" alt="" />';
			htm += 			'<img class="bannerLogo d-lg-none" src="'+commonImgs+'swylHeart_s.png" alt="" />';
			htm += 			'<img class="d-none d-lg-block" src="'+promotionImgs+'60thAnniversary_ribbon_tag599.png" alt="" />';
			htm += 			'<img class="d-none d-md-block d-lg-none" src="'+promotionImgs+'60thAnniversary_ribbon_tag250.png" alt="" />';
			htm += 			'<div class="amounts d-none d-md-block mdAmounts">';
			htm += 				'<a href="https://members.whro.org/?technique=OnlineMainBanner" target="_blank" rel="noopener">Support Now</a>';
			htm += 			'</div>';
			htm += 			'<div class="amounts d-md-none smAmounts">';
			htm += 				'<a href="https://members.whro.org/?technique=OnlineMainBanner" target="_blank" rel="noopener">Support Now</a>';
			htm += 			'</div>';
			htm += 		'</div>';
			htm += '</div>';
		
		
*/			
			/* 
			Radio Pledge 
			- Member Counts
		*/
			
/*
			htm += '<style>';
			htm += '	.pledgeBanner{ font-family:Helvetica,arial;font-weight:bold;color:#fff; background:url("'+commonImgs+'radioPledge_Dec20_ribbon_bkg.jpg") repeat-x transparent 0 0; height:90px; }';
			htm += '	.pledgeBanner .siteBannerInner{ height:90px; justify-content:space-between; }';
			htm += '	.pledgeBanner span{ align-self:center; line-height:1.1; vertical-align:sub; text-align:center; }';
			htm += '	.pledgeBanner span span.d-lg-inline{ vertical-align:baseline; }';
			htm += '	.pledgeBanner span .pledgeCallout{ color:#f2cd00;font-size:32px;}';
			htm += '	.pledgeBanner span .memberCountMessage{ font-size:16px;vertical-align: middle; }';
			htm += '	.pledgeBanner img{ height:100%; }';
			htm += '	.pledgeBanner .bannerLogo{ margin-top:0px; margin-left:1rem; }';
			htm += '	.pledgeBanner a{ width:112px; height:90px; background:url("'+commonImgs+'radioPledge_Dec20_ribbon_btnOff.jpg") no-repeat transparent 0 0; display: inline-block; text-indent: -9000px; }';
			htm += '	.pledgeBanner a:hover{ background:url("'+commonImgs+'radioPledge_Dec20_ribbon_btnOn.jpg") no-repeat transparent 0 0; }';
			htm += '	@media (max-width:575px){ .pledgeBanner .siteBannerInner{ padding-left:4px };  }';
			htm += '	@media (max-width:575px){ .pledgeBanner }';
			htm += '</style>';
			htm += '<div class="siteBanner pledgeBanner">';
			htm += '	<div class="container siteBannerInner d-flex pr0">';
			htm += '		<img class="bannerLogo d-md-none" src="'+commonImgs+'radioPledge_Dec20_ribbon_tag_s.png">';
			htm += 			'<img class="bannerLogo d-none d-md-inline d-lg-none" src="'+commonImgs+'radioPledge_Dec20_ribbon_tag_m.png" alt="" />';
			htm += 			'<img class="bannerLogo d-none d-lg-inline" src="'+commonImgs+'radioPledge_Dec20_ribbon_tag_l.png" alt="" />';
			htm += 			'<span class="d-none d-md-inline"><span class="pledgeCallout pledgeMemberCount"></span>&nbsp;<span class="memberCountMessage">MEMBERS HAVE CONTRIBUTED SO FAR!</span></span>';	
			htm += '		<div class="amounts">';
			htm += '			<div style="margin-left:auto">';
			htm += '				<a class="d-inline-block" href="https://members.whro.org/?technique=OnlineMainBanner" target="_blank">Support Now</a>';
			htm += '			</div>';
			htm += '		</div>';
			htm += '	</div>';
			htm += '</div>';
		
			a = $.ajax({ url : APP_CONFIG.MEMBERS_API_ROOT+'pledgeadmin.json?t='+Date.now() });
			a.done(function(res){
				//rip off cents
				res.Pledge_Web_Total = res.Pledge_Web_Total.split('.');
				//remove non-digits
				res.Pledge_Web_Total = res.Pledge_Web_Total[0].replace(/\D/g,'');
				//add commas back in
				res.Pledge_Web_Total = res.Pledge_Web_Total.replace(/\B(?=(?:\d{3})+(?!\d))/g, ",");
				
				$(document).ready(function(){
					$('.pledgeMemberCount').html( +res.Member_Web_Total );
// 					$('.pledgeRaisedAmount').html("$"+res.Pledge_Web_Total );
				});
			});
*/
			
// 			Radio pledge 
	   	/*
	   		htm += '<style>';
	    	htm += '.pledgeBanner{ background:url("'+promotionImgs+'30th_Sep20_ribbon_bkg.jpg") repeat-x transparent 0 0; height:90px; }';
			htm += '.pledgeBanner .siteBannerInner{ height:90px; justify-content:space-between; }';
			htm += '	@media (max-width:575px){ .pledgeBanner .siteBannerInner { justify-content:space-around; } }';
			
			htm += '.pledgeBanner a{ width:112px; height:90px; background:url("'+promotionImgs+'30th_Sep20_ribbon_btnOff.jpg") no-repeat transparent 0 0; display:inline-block; text-indent:-9000px; }';
			htm += '.pledgeBanner a:hover{ background:url("'+promotionImgs+'30th_Sep20_ribbon_btnOn.jpg") no-repeat transparent 0 0; }';
			htm += '</style>';
	        htm += '<div class="siteBanner pledgeBanner">';
			htm += 		'<div class="container siteBannerInner d-flex">';
			htm += 			'<img class="bannerLogo d-none d-lg-block" src="'+promotionImgs+'30th_Sep20_ribbon_logos.png" alt="" />';
			htm += 			'<img class="bannerLogo d-none d-md-block d-lg-none" src="'+promotionImgs+'30th_Sep20_ribbon_logos.png" alt="" />';
			htm += 			'<img class="d-none d-xl-block" src="'+promotionImgs+'30th_Sep20_ribbon_tag599.png" alt="" />';
			htm += 			'<img class="d-none d-md-block d-xl-none" src="'+promotionImgs+'30th_Sep20_ribbon_tag250.png" alt="" />';
			htm += 			'<img class="d-md-none mobile-view" src="'+promotionImgs+'30th_Sep20_ribbon_tag185.png" alt="" />';
			htm += 			'<div class="amounts">';
			htm += 				'<a href="https://members.whro.org/?technique=OnlineMainBanner" target="_blank" rel="noopener">See Upcoming Programs</a>';
			htm += 			'</div>';
			htm += 		'</div>';
			htm += '</div>';
*/	



/*
			Radio Pledge 
			- Last Day
*/
		

/*
			htm += '<style>';
			htm += '	.pledgeBanner{ background:url("'+commonImgs+'swyl_bkg.jpg") repeat-x transparent 0 0; height:90px; }';
			htm += '	.pledgeBanner .siteBannerInner{ height:90px; justify-content:space-between; }';
			htm += '	.pledgeBanner a{ width:179px; height:40px; background:url("'+commonImgs+'swyl_h_Off.png") no-repeat transparent 0 0; text-indent:-9000px; }';
			htm += '	.pledgeBanner a:hover{ background:url("'+commonImgs+'swyl_h_On.png") no-repeat transparent 0 0; }';
			htm += '	.pledgeBanner .amounts{ line-height:1.5em; }';
			htm += '	@media (max-width:575px){ .pledgeBanner .amounts{ width:100% }  }';
			htm += '	.pledgeBanner .amounts span{ color:#fdfafb; font-weight: normal; font-size: 1.8em; position: relative; top:8px;left:-5px; }';
			htm += '    .pledgeBanner .amounts span span{ position:static; font-size:inherit} ';
			htm += '</style>';
			htm += '<div class="siteBanner pledgeBanner">';
			htm += '	<div class="container siteBannerInner d-flex pr0">';
			htm += '		<img class="bannerLogo d-none d-sm-block" src="'+commonImgs+'swyl_logo.png">';
			htm += '		<img class="d-none d-lg-block" src="'+commonImgs+'VandO_240.png">';
			htm += '		<div class="amounts d-flex">';
			htm += '			<div class="d-inline-block" style="margin:0 auto">';
			htm += '				<div>';
			htm += '					<div class="d-inline-block" style="width:78px;margin-top:5px">';
			//htm += '						<img src="'+commonImgs+'leftToRaise.png" />';
			htm += '					</div>';
			//htm += '					<span class="pledgeAmount_overallTotal">&nbsp;</span>';
			htm += '				</div>';
			htm += '				<div style="margin-top:7px;">';
			htm += '					<a class="d-inline-block mt0 ml2" href="https://members.whro.org/?technique=OnlineMainBanner" target="_blank">Support Now</a>';
			htm += '				</div>';
			htm += '			</div>';
			htm += '		</div>';
			htm += '	</div>';
			htm += '</div>';
		
*/

			/* No amount for this extra pledge week. Put this all back in later
			a = $.ajax({ url : 'https://www.whro.org/shared/getXInfo.php?idx=1' });
			a.done(function(xml){
				var amounts = [];
				amounts.overallTotal = $(xml).find('totals').attr('overall');
				for(var key in amounts){
					if(amounts.hasOwnProperty(key)){
						//rip off cents
						amounts[key] = amounts[key].split('.');
						//remove non-digits
						amounts[key] = amounts[key][0].replace(/\D/g,'');
						//pad if less than 6 digits
						for(var i = amounts[key].length; i<6; i++){
							amounts[key] = "&nbsp;" + amounts[key];
						}
						//add commas back in
						amounts[key] = amounts[key].replace(/\B(?=(?:\d{3})+(?!\d))/g, "<span>,</span>");
					}
				}
		
				$(document).ready(function(){
					$('.pledgeAmount_overallTotal').html(amounts.overallTotal );
				});
			});	
			*/

	}else if(moment().isBetween(thankYouStart,thankYouEnd)){
		/*
			- Thank You TV */
			
/*
			htm += '<style>';
	    	htm += '.pledgeBanner{ background:url("'+commonImgs+'swyl_wine_bkg.jpg") repeat-x transparent 0 0; height:90px; }';
			htm += '.pledgeBanner .siteBannerInner{ height:90px; justify-content:space-between; }';
			htm += '	@media (max-width:750px){ .pledgeBanner .siteBannerInner { justify-content:space-around; } }';
			htm += '.pledgeBanner a{ width:112px; height:90px; background:url("'+commonImgs+'swyl_wine_thankYou_sq_Off.jpg") no-repeat transparent 0 0; display:inline-block; text-indent:-9000px; }';
			htm += '.pledgeBanner a:hover{ background:url("'+commonImgs+'swyl_wine_thankYou_sq_On.jpg") no-repeat transparent 0 0; }';
			htm += '</style>';
	        htm += '<div class="siteBanner pledgeBanner">';
			htm += 		'<div class="container siteBannerInner d-flex">';
			htm += 			'<img class="bannerLogo d-none d-md-block" src="'+commonImgs+'supportWhatYouLove.png" alt="" />';
			htm += 			'<img class="bannerLogo d-none" src="'+commonImgs+'supportWhatYouLove_s.png" alt="" />';
			htm += '		<img class="d-none d-lg-block" src="'+commonImgs+'swyl_wine_thanks_599.png">';
			htm += '		<img class="d-lg-none d-md-block" src="'+commonImgs+'swyl_wine_thanks_250.png">';
			htm += 			'<div class="amounts">';
			htm += 				'<a href="https://support.whro.org/pledge-thank-you" target="_blank">Thank You</a>';
			htm += 			'</div>';
			htm += 		'</div>';
			htm += '</div>';
*/	
	
		/*
			- Radio TV
		*/
		
		/*
			htm += '<style>';
			htm += '.pledgeBanner{ background-color:#67aee0; height:90px; }';
			htm += '.pledgeBanner .siteBannerInner{ height:90px; justify-content:space-between; }';
			htm += '.pledgeBanner a{ width:112px; height:90px; background:url("'+commonImgs+'btn_thankYou60_sq_On.png") no-repeat transparent 0 0; display:inline-block; text-indent:-9000px; }';
			htm += '.pledgeBanner a:hover{ background:url("'+commonImgs+'btn_thankYou60_sq_Off.png") no-repeat transparent 0 0; }';
			htm += '</style>';
	        htm += '<div class="siteBanner pledgeBanner">';
			htm += 		'<div class="container siteBannerInner d-flex">';
			htm += '		<img class="bannerLogo d-md-none" src="'+commonImgs+'swylHeart_s.png">';
			htm += 			'<img class="bannerLogo d-none d-md-inline" src="'+commonImgs+'swylHeart_l.png" alt="" />';
			htm += '		<img class="d-none d-lg-block" src="'+commonImgs+'thankYou_599.png">';
			htm += '		<img class="d-none d-md-block d-lg-none" src="'+commonImgs+'thankYou_250.png">';
			htm += 			'<div class="amounts">';
			htm += 				'<a href="https://support.whro.org/pledge-thank-you" target="_blank">Thank You</a>';
			htm += 			'</div>';
			htm += 		'</div>';
			htm += '</div>';
			*/
		
// 			- End of Year
			

/*


			htm += '<style>';
	    	htm += '.pledgeBanner{ background:url("'+commonImgs+'winter_bkg.jpg") repeat-x transparent 0 0; height:90px; }';
			htm += '.pledgeBanner .siteBannerInner{ height:90px; justify-content:space-between; }';
			htm += '.pledgeBanner a{ width:112px; height:90px; background:url("'+commonImgs+'winter_sq_Off.jpg") no-repeat transparent 0 0; display:inline-block; text-indent:-9000px; }';
			htm += '.pledgeBanner a:hover{ background:url("'+commonImgs+'winter_sq_On.jpg") no-repeat transparent 0 0; }';
			htm += '</style>';
	        htm += '<div class="siteBanner pledgeBanner">';
			htm += 		'<div class="container siteBannerInner d-flex">';
			htm += 			'<img class="bannerLogo" src="'+commonImgs+'winter_swyl_logo.png" />';
			htm += '		<img class="d-none d-lg-block" src="'+pledgeImgs+'EOCY2019_599.png">';
			htm += '		<img class="d-none d-md-block d-lg-none" src="'+pledgeImgs+'EOCY2019_250.png">';
			htm += 			'<div class="amounts">';
			htm += 				'<a href="https://members.whro.org/?technique=EOCY" target="_blank">Support Now</a>';
			htm += 			'</div>';
			htm += 		'</div>';
			htm += '</div>';	

*/
		
	}
    
    return new (Marionette.View.extend({
    	template: _.template(htm)
    }))();
});